import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import type { Asset } from '../../../../api/models/asset.model';

interface SerialNumberUpdateProps {
	selectedRecords: Asset[];
	onChange: (data: { assetId: number; newSerialNumber: string }[]) => void;
}

const SerialNumberUpdate: React.FC<SerialNumberUpdateProps> = ({
	selectedRecords: assets,
	onChange,
}) => {
	const [serials, setSerials] = useState<{ [assetId: number]: string }>({});

	const handleSerialChange = (assetId: number, value: string) => {
		const updated = { ...serials, [assetId]: value };
		setSerials(updated);
		const result = assets.map((asset) => ({
			assetId: Number(asset.assetId!),
			newSerialNumber: updated[Number(asset.assetId!)] || '',
		}));
		onChange(result);
	};

	return (
		<Box sx={{ mt: 2, mb: 2 }}>
			<TableContainer component={Box}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: (theme) => theme.palette.surface.tertiary,
						px: 2,
						py: 1,
						borderRadius: 1,
						mb: 1,
						borderTop: '1px solid',
						borderColor: (theme) => theme.palette.divider,
					}}
				>
					<Typography variant="subtitle1" mb={1}>
						Assets
					</Typography>
				</Box>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>
								<Typography fontWeight={700} data-testid="request-modal-header-asset-number">
									Asset Number
								</Typography>
							</TableCell>
							<TableCell>
								<Typography fontWeight={700} data-testid="request-modal-header-asset-serial-number">
									Serial Number
								</Typography>
							</TableCell>
							<TableCell>
								<Typography fontWeight={700} data-testid="request-modal-header-asset-description">
									Description
								</Typography>
							</TableCell>
							<TableCell>
								<Typography
									fontWeight={700}
									data-testid="request-modal-header-asset-new-serial-number"
								>
									New Serial Number
								</Typography>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{assets.map((asset) => (
							<TableRow key={asset.assetId}>
								<TableCell>{asset.assetNumber}</TableCell>
								<TableCell>{asset.serialNumber}</TableCell>
								<TableCell>{asset.itemDescription}</TableCell>
								<TableCell>
									<TextField
										size="small"
										value={serials[Number(asset.assetId!)] || ''}
										onChange={(e) => handleSerialChange(Number(asset.assetId!), e.target.value)}
										slotProps={{
											htmlInput: { 'data-testid': `serial-number-input-${asset.assetNumber}` },
										}}
									/>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default SerialNumberUpdate;
